import { logs } from '@/translations/en/blockly/logs' //skip-export

export const blockly = {
  editor: 'Blockly Editor',
  editorDescription:
    'Using variables and blocks you can create rules that will control the configuration view for the user.',
  variables: 'Variables',
  variablesFor: 'Variables for {name}',
  variableList: 'Variable list',
  variableSearch: 'Search variables',
  noVariablesFound: 'No variables found for selected type',
  goBack: 'Go back',
  saveChanges: 'Save',
  undo: 'Undo',
  unsavedChanges:
    'Changes have been made to the rules. Don’t forget to save them.',
  unsavedChangesTitle: 'Unsaved changes',
  unsavedChangesDescription:
    'Are you sure you want to leave this page? Your changes will not be saved.',
  undoOne: 'Undo 1 step',
  undoAll: 'Undo all',
  form: {
    label: 'Name',
    description: 'Description',
  },
  success: {
    successTittle: 'Success!',
    ruleCreated: 'Rule created',
    ruleUpdated: 'Rule updated',
  },
  errors: {
    fetchFlowError: 'Error while fetching flow',
    saveError: 'Error while saving rule',
    fetchPropertiesError: 'Error while fetching properties',
  },
  toolbox: {
    categories: 'Categories',
    logic: 'Logic',
    math: 'Math',
    variables: 'All variables',
    text: 'Text',
    custom: 'Appearance',
  },
  groupContainer: {
    label: 'Group: ',
    namePlaceholder: 'Name',
    tooltip: 'Visually groups blocks under the given name.',
  },
  logs,
}
